import React from 'react';
import '../../styles/css/ChatBubble.css';

const ChatBubble = ({ message, sender, animationClass }) => {
  const isUser = sender === 'user';

  return (
    <div className={`chat-bubble-container ${isUser ? 'user' : ''}`}>
      <div className={`chat-bubble ${isUser ? 'user' : 'server'} ${animationClass || ''}`}>
        {message}
      </div>
    </div>
  );
};

export default ChatBubble;
